import React, { ReactNode } from 'react';
import { Typography } from 'antd';
import './SectionHeader.less';

const { Title, Text } = Typography;

export interface SectionHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  extra?: ReactNode;
  divider?: boolean;
  children?: ReactNode;
  className?: string;
  contentClassName?: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  description,
  extra,
  divider = true,
  children,
  className = '',
  contentClassName = '',
}) => {
  return (
    <section className={`gt-section-header ${className}`}>
      <header className="gt-section-header-row">
        <div className="gt-section-header-text">
          <Title level={4} className="gt-section-header-title">
            {title}
          </Title>
          {description && (
            <Text className="gt-section-header-description">{description}</Text>
          )}
        </div>
        {extra && <div className="gt-section-header-extra">{extra}</div>}
      </header>

      {divider && <div className="gt-section-header-divider" role="separator" />}

      {children && (
        <div className={`gt-section-header-content ${contentClassName}`}>
          {children}
        </div>
      )}
    </section>
  );
};

export default SectionHeader;
